module.exports = __webpack_public_path__ + "img/spinner.811412e.svg";